import {IABTestConfiguration, useABTest} from "@pg-mono/ab-testing";
import {flushAmplitude, trackAmplitudeExperimentExposure, waitForAmplitudeInitialization} from "@pg-mono/amplitude";

import {UNLOCK_CHOICE_EXPOSURE_FLUSH_TIMEOUT_MS} from "../constants/unlock_choice_timeouts";

export interface IBinaryExperimentConfig {
    abTest: IABTestConfiguration;
    controlVariant: string;
    treatmentVariant: string;
}

interface IUseBinaryExperimentParams {
    isEnabled: boolean;
}

export interface ITrackExperimentExposureOptions {
    /** The page is about to be left - the exposure goes out right away instead of with the next batch */
    isLeavingPage?: boolean;
}

export interface IBinaryExperiment {
    /** The test has settled - either a variant is assigned or the user has no assignment at all */
    isResolved: boolean;
    /** The user has a control or treatment assignment */
    isAssigned: boolean;
    isTreatment: boolean;
    /** Reports the exposure of an assigned user to the data layer and Amplitude, does nothing otherwise */
    trackExposure: (options?: ITrackExperimentExposureOptions) => Promise<void>;
}

const pushExperienceImpression = (abTestId: string, variant: string) => {
    const expVariantString = `${abTestId}.${variant}`;

    window.dataLayer = window.dataLayer || [];

    const isReported = window.dataLayer.some((item) => "exp_variant_string" in item && item.exp_variant_string === expVariantString);

    if (!isReported) {
        window.dataLayer.push({event: "experience_impression", exp_variant_string: expVariantString});
    }
};

const flushAmplitudeWithinTimeout = () =>
    Promise.race([flushAmplitude().catch(() => undefined), new Promise<void>((resolve) => setTimeout(resolve, UNLOCK_CHOICE_EXPOSURE_FLUSH_TIMEOUT_MS))]);

export const useBinaryExperiment = (config: IBinaryExperimentConfig, {isEnabled}: IUseBinaryExperimentParams): IBinaryExperiment => {
    const {abTest, controlVariant, treatmentVariant} = config;
    const {canABTestBeRendered, abTestVariant} = useABTest({
        id: abTest.id,
        variants: abTest.variants,
        withSSR: abTest.withSSR,
        disableEventPush: true
    });
    const variant = canABTestBeRendered && (abTestVariant === controlVariant || abTestVariant === treatmentVariant) ? abTestVariant : null;

    const trackExposure = async ({isLeavingPage = false}: ITrackExperimentExposureOptions = {}) => {
        if (!isEnabled || variant === null) {
            return;
        }

        if (isLeavingPage) {
            pushExperienceImpression(abTest.id, variant);
        } else {
            useABTest.dataLayerQueue.pushEvent({id: abTest.id, variant, pushOnlyOnce: true});
        }

        await waitForAmplitudeInitialization().catch(() => undefined);
        trackAmplitudeExperimentExposure(abTest.id);

        if (isLeavingPage) {
            await flushAmplitudeWithinTimeout();
        }
    };

    return {
        isResolved: canABTestBeRendered,
        isAssigned: variant !== null,
        isTreatment: variant === treatmentVariant,
        trackExposure
    };
};
import {IABTestConfiguration, useABTest} from "@pg-mono/ab-testing";
import {flushAmplitude, trackAmplitudeExperimentExposure, waitForAmplitudeInitialization} from "@pg-mono/amplitude";

import {UNLOCK_CHOICE_EXPOSURE_FLUSH_TIMEOUT_MS} from "../constants/unlock_choice_timeouts";

export interface IBinaryExperimentConfig {
    abTest: IABTestConfiguration;
    controlVariant: string;
    treatmentVariant: string;
}

interface IUseBinaryExperimentParams {
    isEnabled: boolean;
}

export interface ITrackExperimentExposureOptions {
    /** The page is about to be left - the exposure goes out right away instead of with the next batch */
    isLeavingPage?: boolean;
}

export interface IBinaryExperiment {
    /** The test has settled - either a variant is assigned or the user has no assignment at all */
    isResolved: boolean;
    /** The user has a control or treatment assignment */
    isAssigned: boolean;
    isTreatment: boolean;
    /** Reports the exposure of an assigned user to the data layer and Amplitude, does nothing otherwise */
    trackExposure: (options?: ITrackExperimentExposureOptions) => Promise<void>;
}

const pushExperienceImpression = (abTestId: string, variant: string) => {
    const expVariantString = `${abTestId}.${variant}`;

    window.dataLayer = window.dataLayer || [];

    const isReported = window.dataLayer.some((item) => "exp_variant_string" in item && item.exp_variant_string === expVariantString);

    if (!isReported) {
        window.dataLayer.push({event: "experience_impression", exp_variant_string: expVariantString});
    }
};

const flushAmplitudeWithinTimeout = () =>
    Promise.race([flushAmplitude().catch(() => undefined), new Promise<void>((resolve) => setTimeout(resolve, UNLOCK_CHOICE_EXPOSURE_FLUSH_TIMEOUT_MS))]);

export const useBinaryExperiment = (config: IBinaryExperimentConfig, {isEnabled}: IUseBinaryExperimentParams): IBinaryExperiment => {
    const {abTest, controlVariant, treatmentVariant} = config;
    const {canABTestBeRendered, abTestVariant} = useABTest({
        id: abTest.id,
        variants: abTest.variants,
        withSSR: abTest.withSSR,
        disableEventPush: true
    });
    const variant = canABTestBeRendered && (abTestVariant === controlVariant || abTestVariant === treatmentVariant) ? abTestVariant : null;

    const trackExposure = async ({isLeavingPage = false}: ITrackExperimentExposureOptions = {}) => {
        if (!isEnabled || variant === null) {
            return;
        }

        if (isLeavingPage) {
            pushExperienceImpression(abTest.id, variant);
        } else {
            useABTest.dataLayerQueue.pushEvent({id: abTest.id, variant, pushOnlyOnce: true});
        }

        await waitForAmplitudeInitialization().catch(() => undefined);
        trackAmplitudeExperimentExposure(abTest.id);

        if (isLeavingPage) {
            await flushAmplitudeWithinTimeout();
        }
    };

    return {
        isResolved: canABTestBeRendered,
        isAssigned: variant !== null,
        isTreatment: variant === treatmentVariant,
        trackExposure
    };
};
